export const enum TextOperator {
    Equal = '=',
    NotEqual = '!=',
    Contains = '⊃',
    NotContains = '⊅',
    StartsWith = '^',
    EndsWith = '$',
}
